export const TC_UPLOAD_REQUEST = "TC_UPLOAD_REQUEST";
export const TC_UPLOAD_SUCCESS = "TC_UPLOAD_SUCCESS";
export const TC_UPLOAD_FAIL = "TC_UPLOAD_FAIL";

export const PDF_RETRIEVE_REQUEST = "PDF_RETRIEVE_REQUEST";
export const PDF_RETRIEVE_SUCCESS = "PDF_RETRIEVE_SUCCESS";
export const PDF_RETRIEVE_FAIL = "PDF_RETRIEVE_FAIL";
